import SendMessageFormV2 from "./sendMessageFormV2";

export default SendMessageFormV2;
